var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.492,
    height: 24,
    viewBox: "0 0 19.492 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(0.003 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8975",
    "data-name": "Path 8975",
    d: "M222.979,154.7a.581.581,0,0,0-.581.581v10.974a.581.581,0,0,0,1.161,0V155.284A.581.581,0,0,0,222.979,154.7Zm0,0",
    transform: "translate(-209.926 -146.515)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8976",
    "data-name": "Path 8976",
    d: "M104.979,154.7a.581.581,0,0,0-.581.581v10.974a.581.581,0,0,0,1.161,0V155.284A.581.581,0,0,0,104.979,154.7Zm0,0",
    transform: "translate(-98.545 -146.515)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8977",
    "data-name": "Path 8977",
    d: "M1.593,7.144V20.991a3.1,3.1,0,0,0,.824,2.139A2.768,2.768,0,0,0,4.426,24H15.06a2.767,2.767,0,0,0,2.008-.868,3.1,3.1,0,0,0,.824-2.139V7.144a2.147,2.147,0,0,0-.551-4.222H14.464v-.7A2.208,2.208,0,0,0,12.238,0H7.247a2.208,2.208,0,0,0-2.226,2.22v.7H2.144a2.147,2.147,0,0,0-.551,4.222ZM15.06,22.874H4.426a1.78,1.78,0,0,1-1.709-1.883V7.193H16.769v13.8a1.78,1.78,0,0,1-1.709,1.883ZM6.146,2.219a1.083,1.083,0,0,1,1.1-1.1h4.991a1.083,1.083,0,0,1,1.1,1.1v.7H6.146Zm-4,1.827h15.2a1.012,1.012,0,0,1,0,2.023H2.144a1.012,1.012,0,0,1,0-2.023Zm0,0",
    transform: "translate(0 0)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8978",
    "data-name": "Path 8978",
    d: "M163.979,154.7a.581.581,0,0,0-.581.581v10.974a.581.581,0,0,0,1.161,0V155.284A.581.581,0,0,0,163.979,154.7Zm0,0",
    transform: "translate(-154.236 -146.515)",
    fill: "#c8c8c8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.38260c9939fe6cf9c99c8b3ecfbd1bd4.svg";
export { ForwardRef as ReactComponent };